import { jsx as _jsx } from "react/jsx-runtime";

/* 
    this component return next button for pagination
*/
import React from "react";
import styles from "./NextButton.module.scss";
import { handleNextPage } from "../../services";

var NextButton = function NextButton(_ref) {
  var selected = _ref.selected,
      pageCount = _ref.pageCount,
      setSelected = _ref.setSelected,
      onPageChange = _ref.onPageChange,
      nextLabel = _ref.nextLabel;
  //if slected page equal to last page we set disabled class to next button
  var nextClasses = [styles.next, selected === pageCount - 1 ? styles.disabled : ""].join(" ");
  return /*#__PURE__*/_jsx("li", {
    className: nextClasses,
    children: /*#__PURE__*/_jsx("a", {
      className: styles.nextLink,
      onClick: function onClick() {
        return handleNextPage(selected, pageCount, setSelected, onPageChange);
      },
      children: /*#__PURE__*/_jsx("img", {
        src: "/images/pagination/arrow right.svg"
      })
    })
  });
};

export default NextButton;